import { StaffRequest } from '../../lib/types/models/staff-request/staff-request'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffRequest(id: number) {
  return restApiClient.url(constructApiUrl(API.staffRequest.get.url, { id })).get<StaffRequest>()
}
